// extracted by mini-css-extract-plugin
export default {"card":"TrackingResults_card__DWyl-","list":"TrackingResults_list__RdeZ3"};